





































import { defineComponent, PropType } from '@nuxtjs/composition-api';
import { useTranslations } from '@vue-storefront/novulo';
import { addCurrency, priceFormat } from '~/helpers/utils';

type ProductThumbnail = {
  brand?: string;
  image: string;
  alt?: string;
  itemNo?: string;
  price?: number;
  promotionPrice?: number;
  cashbackPrice?: number;
  title: string;
  url: string;
  description?: string;
};

export default defineComponent({
  components: {},
  props: {
    variant: {
      type: String as PropType<
        'product' | 'product-price' | 'inspiration' | 'article'
      >,
      default: 'product'
    },
    product: {
      type: Object as PropType<ProductThumbnail>,
      default: () => ({
        itemNo: '',
        title: '',
        price: 0,
        brand: '',
        image: '',
        url: '',
        description: ''
      })
    }
  },
  setup(props) {
    const { translate } = useTranslations();

    return {
      addCurrency,
      priceFormat,
      translate,
      handleClick: () => {
        const url = props.product.url;
        if (!url) return;

        if (url.startsWith('http://') || url.startsWith('https://')) {
          location.href = url;
          return;
        }

        location.href = url.startsWith('/') ? url : `/${url}`;
      }
    };
  }
});
